import { push } from '@lagunovsky/redux-react-router'
import { isNil, pick } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import WaitAction from 'wait/WaitAction'
import { H_HYDRO_EXPORT } from '../../../account/constants/AccessRulesConstants'
import ActionComponent from '../../../components/ActionComponent'
import { CardTitle } from '../../../components/card/NewCard'
import { darkBlue } from '../../../utils/constants/ColorTheme'
import { CardTable, SORT } from '../../../components/datatable/NewTable'
import Select from '../../../components/forms/Select'
import SelectStationModal from '../../../components/modal/SelectStationModal'
import ExportAction from '../../../export/actions/ExportAction'
import {
    CSV_EXPORT,
    EXCEL_EXPORT,
    EXPORT_JOB_ID_ONE_OFF,
    EXPORT_JOB_ID_SCHEDULED,
    EXPORT_JOB_STATUS,
    EXPORT_STATIONS_MEASURES,
    EXPORT_STATIONS_MODELS,
    EXPORT_TYPE_OPTIONS,
    MODEL_EXPORT,
} from '../../../export/constants/ExportConstants'
import HomeAction from '../../../home/actions/HomeAction'
import DtoParametrageDataType from '../../../piezometry/dto/DtoParametrageDataType'
import { nbPerPageLabelTiny } from '../../../referencial/constants/ReferencialConstants'
import StationAction from '../../../station/actions/StationAction'
import StationsExcelExportPanel from '../../../station/components/StationsExcelExportPanel'
import StationsModelExportPanel from '../../../station/components/StationsModelExportPanel'
import StationsPointPrelTable from '../../../station/components/StationsPointPrelTable'
import ScheduledExportEditModal from '../../../export/components/ScheduledExportEditModal'
import DtoExportJob from '../../../station/dto/DtoExportJob'
import { getDateExport, getFullDate } from '../../../utils/DateUtil'
import { FILE_LABEL_HEADER, SCHEDULED_FILE_LABEL_HEADER, SCHEDULED_JOB_HEADER, SCHEDULED_NAME_HEADER, getEllipsisCell, getExportDuration, getLoadingBar, getStatusCell, STATUS_HEADER } from '../../../utils/ExportJobUtils'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { nFormatter } from '../../../utils/NumberUtil'
import { getLogin } from '../../../utils/SettingUtils'
import HydrometryAction from '../../actions/HydrometryAction'
import DtoHydrometricStation from '../../dto/DtoHydrometricStation'
import Checkbox from '../../../components/forms/Checkbox'
import Input from '../../../components/forms/Input'
import { setConfirmationModal } from '../../../utils/FormUtils'
import { STATION_TYPE_NAME } from '../../../station/constants/StationConstants'
import { Box, Card, CardContent, Grid } from '@mui/material'
import JobAction from '../../../import/actions/JobAction'
import DtojobTable from '../../../import/dto/DtoJobTable'

class HydrometricStationsExportApp extends ActionComponent {
    isCheckingProgress = false
    remainingEmptyChecks = 0

    state = {
        exportType: undefined,
        model: 0,
        tmpFilter: {
            startDate: undefined,
            endDate: undefined,
            group: 'BRUTE',
            withStatusQualificationCodes: false,
            exportDir: 'EXPORT/tmp',
        },
        selectStationIsOpen: false,
        selectedStations: [],
        pointsPrel: [],
        dataType: 0,
        jobs: [],
        jobId: EXPORT_JOB_ID_SCHEDULED,
        editJobId: EXPORT_JOB_ID_SCHEDULED,
        noZip: false,
        editOpen: false,
        editExport: undefined,
    }

    setTitle = () => {
        this.props.setTitle([{
            title: i18n.hydrometry,
            href: 'hydrometry',
        }, {
            title: i18n.export,
            href: 'hydrometry',
        }])
    }

    recursiveFetchExportJob = () => {
        if (!this.isCheckingProgress) {
            return
        }
        this.props.fetchExportJobsTmp('hydrometry').then(response => {
            const isRunning = response.some(e => e.status === EXPORT_JOB_STATUS.WAITING || e.status === EXPORT_JOB_STATUS.IN_PROGRESS)
            this.remainingEmptyChecks = isRunning ? 0 : this.remainingEmptyChecks - 1
            if (isRunning || this.remainingEmptyChecks > 0) {
                setTimeout(() => this.recursiveFetchExportJob(), 5000)
            } else {
                this.isCheckingProgress = false
            }
        })
    }

    regularProgressUpdate = (emptyChecks = 0) => {
        this.remainingEmptyChecks = Math.max(this.remainingEmptyChecks, emptyChecks)
        if (this.isCheckingProgress) {
            return
        }
        this.isCheckingProgress = true
        this.recursiveFetchExportJob()
    }

    componentDidMount() {
        if (!componentHasHabilitations(H_HYDRO_EXPORT)) { // A modifier quand react-router sera à jour
            this.props.push('/unauthorized')
            return
        }
        this.setTitle()
        this.props.fetchEnvironmentModelsByType('hydrometry')
        this.props.fetchHydrometryDataTypes()
        this.props.fetchStationPointsPrel(STATION_TYPE_NAME.hydrometry)
        this.regularProgressUpdate()
        JobAction.promiseJobTable({ jobType: 'exportTmpScheduled', displayMode: 'job' })
            .then(jobs => this.setState({ jobs: (jobs?.data ?? []).map(j => new DtojobTable(j)) }))
    }

    componentWillUnmount() {
        this.isCheckingProgress = false
    }

    onChangeFilter = (value) => {
        this.setState(({ tmpFilter }) => ({ tmpFilter: { ...tmpFilter, ...value } }))
    }

    onChange = (value) => {
        this.setState(value)
    }

    onCloseModal = () => {
        this.setState({ selectStationIsOpen: false })
    }

    onApplyExport = (type) => {
        const { tmpFilter, dataType, selectedStations, pointsPrel, jobId, noZip } = this.state
        const { waitStart, waitStop, hydrometryDataTypes } = this.props
        waitStart()
        const selectedDataTypes = hydrometryDataTypes.filter(d => !dataType || d.id === dataType)
        const exportData = {
            exportData: selectedStations.map(h => ({
                station: pick({ ...h, stationType: h.typeName }, ['id', 'code', 'name', 'stationType']),
                exportType: type,
                filename: `${h.code}_${getDateExport()}`,
                codePoint: pointsPrel.find(pp => pp.idStation === h.id)?.code,
            })),
            startDate: tmpFilter.startDate,
            group: tmpFilter.group,
            endDate: tmpFilter.endDate,
            status: tmpFilter.status,
            qualifications: tmpFilter.qualifications,
            dataTypes: selectedDataTypes.map(({ id, label }) => ({ id, name: label })),
            withStatusQualificationCodes: tmpFilter.withStatusQualificationCodes,
            exportDir: tmpFilter.exportDir,
            noZip,
        }
        if (exportData.exportData.length === 0) {
            this.props.toastrWarning(i18n.noDataOverSelectedStationsAndPeriod)
            waitStop()
            return
        }
        if (this.state.scheduledOnJob && (!this.state.name || isNil(this.state.jobId))) {
            this.props.toastrWarning(i18n.pleaseRequiredFields)
            waitStop()
            return
        }
        const exportTmpObj = {
            id: 0,
            exportType: EXPORT_STATIONS_MEASURES,
            jobId,
            login: getLogin(),
            creationDate: 0,
            status: EXPORT_JOB_STATUS.WAITING,
            stationType: 'hydrometry',
            params: JSON.stringify(exportData),
            scheduledOnJob: this.state.scheduledOnJob,
            name: this.state.name,
        }
        this.props.runExportTmp(exportTmpObj).then(() => {
            if (!this.isCheckingProgress) {
                this.regularProgressUpdate()
            }
        })
        if (this.state.editExport) {
            this.props.updateExportTmp({ ...this.state.editExport, params: JSON.stringify(exportData), jobId: this.state.editJobId })
        }
        waitStop()
    }
    onApplyExportModel = (modelFileName) => {
        const { selectedStations, pointsPrel, tmpFilter, jobId, noZip } = this.state
        const { waitStart, waitStop } = this.props
        const fileNameSplit = modelFileName.split('.')
        const type = fileNameSplit[fileNameSplit.length - 1]
        waitStart()
        const exportData = {
            exportData: selectedStations.map(h => ({
                station: pick({ ...h, stationType: h.typeName }, ['id', 'code', 'name', 'stationType']),
                exportType: type,
                filename: `${h.code}_${getDateExport()}`,
                codePoint: pointsPrel.find(pp => pp.idStation === h.id)?.code,
            })),
            model: modelFileName,
            exportDir: tmpFilter.exportDir,
            noZip,
        }

        if (exportData.exportData.length === 0) {
            this.props.toastrWarning(i18n.noDataOverSelectedStationsAndModel)
            waitStop()
            return
        }
        if (this.state.scheduledOnJob && (!this.state.name || isNil(this.state.jobId))) {
            this.props.toastrWarning(i18n.pleaseRequiredFields)
            waitStop()
            return
        }
        const exportTmpObj = {
            id: 0,
            exportType: EXPORT_STATIONS_MODELS,
            jobId,
            login: getLogin(),
            creationDate: 0,
            status: EXPORT_JOB_STATUS.WAITING,
            stationType: 'hydrometry',
            params: JSON.stringify(exportData),
        }
        this.props.runExportTmp(exportTmpObj).then(() => {
            if (!this.isCheckingProgress) {
                this.regularProgressUpdate()
            }
        })
        if (this.state.editExport) {
            this.props.updateExportTmp({ ...this.state.editExport, params: JSON.stringify(exportData), jobId: this.state.editJobId })
        }
        waitStop()
    }
    getModelTypesOptions = () => this.props.typeEnvironmentModels
        .filter(t => !t.includes('.xls') || !t.includes('.doc'))
        .map((t, i) => ({ value: i, name: t }))

    openEditExport = (exportTmp) => {
        const params = JSON.parse(exportTmp.params ?? '{}')
        const isModel = exportTmp.exportType === EXPORT_STATIONS_MODELS
        const exportType = isModel ? MODEL_EXPORT : (exportTmp.fileType === 'xlsx' ? EXCEL_EXPORT : CSV_EXPORT)
        const stations = params.exportData ?? []
        this.setState({
            editOpen: true,
            editExport: exportTmp,
            exportType,
            selectedStations: stations.map(d => ({ ...d.station, typeName: d.station.stationType })),
            pointsPrel: stations.filter(d => d.codePoint).map(d => ({ idStation: d.station.id, code: d.codePoint })),
            dataType: params.dataTypes?.length === 1 ? params.dataTypes[0].id : 0,
            noZip: params.noZip ?? false,
            model: isModel ? (this.getModelTypesOptions().find(m => m.name === params.model)?.value ?? 0) : 0,
            tmpFilter: {
                startDate: params.startDate,
                endDate: params.endDate,
                group: params.group ?? 'BRUTE',
                status: params.status,
                qualifications: params.qualifications,
                withStatusQualificationCodes: params.withStatusQualificationCodes ?? false,
                exportDir: params.exportDir ?? 'EXPORT/tmp',
            },
            editJobId: exportTmp.jobId ?? EXPORT_JOB_ID_SCHEDULED,
            // relance = run ponctuel
            scheduledOnJob: false,
            jobId: EXPORT_JOB_ID_ONE_OFF,
            name: undefined,
        })
    }

    resetForm = () => this.setState({
        exportType: undefined,
        model: 0,
        tmpFilter: { startDate: undefined, endDate: undefined, group: 'BRUTE', withStatusQualificationCodes: false, exportDir: 'EXPORT/tmp' },
        selectedStations: [],
        pointsPrel: [],
        dataType: 0,
        jobId: EXPORT_JOB_ID_SCHEDULED,
        editJobId: EXPORT_JOB_ID_SCHEDULED,
        noZip: false,
        scheduledOnJob: false,
        name: undefined,
    })

    closeEditExport = () => {
        this.resetForm()
        this.setState({ editOpen: false, editExport: undefined })
    }

    onSaveAndRunEdit = () => {
        const { exportType, model } = this.state
        if (exportType === MODEL_EXPORT) {
            this.onApplyExportModel(this.getModelTypesOptions().find(m => m.value === model)?.name)
        } else {
            this.onApplyExport(exportType === EXCEL_EXPORT ? 'xlsx' : 'csv')
        }
        this.closeEditExport()
    }

    getExportPanel = ({ inPopin = false } = {}) => {
        const { exportType, tmpFilter, selectedStations, model } = this.state
        const modelTypesOptions = this.getModelTypesOptions()
        if (exportType === MODEL_EXPORT) {
            return (
                <StationsModelExportPanel
                    onApplyExportModel = {this.onApplyExportModel}
                    selectedStations={selectedStations}
                    model={model}
                    modelTypesOptions={modelTypesOptions}
                    onChange={this.onChange}
                    onChangeFilter={this.onChangeFilter}
                    tmpFilter={tmpFilter}
                    stationType='hydrometry'
                    hideApplyButton={inPopin}
                />
            )
        } else if ([CSV_EXPORT, EXCEL_EXPORT].includes(exportType)) {
            return (
                <StationsExcelExportPanel
                    onChangeFilter={this.onChangeFilter}
                    onChange={this.onChange}
                    onApplyExport={() => this.onApplyExport(exportType === EXCEL_EXPORT ? 'xlsx' : 'csv')}
                    selectedStations={selectedStations}
                    tmpFilter={tmpFilter}
                    dataTypes={this.props.hydrometryDataTypes}
                    selectedDataType={this.state.dataType}
                    stationType={STATION_TYPE_NAME.hydrometry}
                    hideApplyButton={inPopin}
                />
            )
        }
        return null
    }

    render() {
        const toData = (exports) => exports.map(e => ({
            ...e,
            exportTmp: e,
            name: getEllipsisCell(e.name),
            status: getStatusCell(e.status),
            type: { value: e.fileType },
            creationDate: { value: getFullDate(e.creationDate), format: 'dd/MM/yyyy HH:mm:ss', cellType: 'date' },
            lastExecutionDate: { value: getFullDate(e.updateDate), sortValue: e.updateDate, format: 'dd/MM/yyyy HH:mm:ss', cellType: 'date' },
            author: { value: e.login },
            exportName: { value: i18n[e.exportType] },
            fileLabel: getEllipsisCell(e.filePath === 'NOFILE' ? '' : e.filePath),
            progression: { value: e.filePath === 'NOFILE' ? '' : getLoadingBar(e.status, e.progress, e.filePath) },
            size: { value: nFormatter(e.fileSize) },
            job: getEllipsisCell(this.state.jobs.find(j => j.jobId === e.jobId)?.jobName ?? ''),
            duration: { value: getExportDuration(e) },
        }))
        const dataCurrentExports = toData(this.props.exportJobsTmp.filter(e => !e.scheduledOnJob))
        const dataScheduledExports = toData(this.props.exportJobsTmp.filter(e => e.scheduledOnJob))
        return (
            <Grid container>
                <Grid size={12} container direction='column' spacing={1}>
                    <Card>
                        <CardTitle title={ i18n.export } color={ darkBlue } />
                        <CardContent>
                            <Grid container alignItems='center' spacing={1}>
                                <Grid size={2}>
                                    <Select
                                        label={ i18n.exportName }
                                        options={ EXPORT_TYPE_OPTIONS }
                                        onChange={ v => this.setState({ exportType: v }) }
                                        obligatory
                                        value={ this.state.exportType }
                                    />
                                </Grid>
                                <Grid size={2} className='padding-top-1'>
                                    <Checkbox
                                        label={ i18n.autoProg }
                                        checked={ this.state.scheduledOnJob }
                                        onChange={ v => this.setState({ scheduledOnJob: v, name: undefined, jobId: v ? undefined : EXPORT_JOB_ID_SCHEDULED }) }
                                    />
                                </Grid>
                                { this.state.scheduledOnJob && (
                                    <>
                                        <Grid size={2}>
                                            <Input
                                                title={ i18n.name }
                                                obligatory
                                                value={ this.state.name }
                                                onChange={ v => this.setState({ name: v }) }
                                            />
                                        </Grid>
                                        <Grid size={3}>
                                            <Select
                                                label={ i18n.job }
                                                options={ this.state.jobs }
                                                onChange={ v => this.setState({ jobId: v }) }
                                                obligatory
                                                value={ this.state.jobId }
                                                keyValue='jobId'
                                                keyLabel='jobName'
                                            />
                                        </Grid>
                                    </>
                                ) }
                                <Grid size={3} className='padding-top-1'>
                                    <Checkbox
                                        label={ i18n.noZipExport }
                                        checked={ this.state.noZip }
                                        onChange={ v => this.setState({ noZip: v }) }
                                    />
                                </Grid>
                            </Grid>
                            { this.getExportPanel() }
                            <Box sx={{ paddingTop: this.state.selectedStations.length ? 1 : 0 }}>
                                <StationsPointPrelTable
                                    stations={ this.state.selectedStations.map(s => ({ id: s.id, code: s.code, name: s.name })) }
                                    pointsPrel={ this.state.pointsPrel }
                                    points={ this.props.stationPointsPrel }
                                    dataType={ this.state.dataType }
                                    onChange={ v => this.setState({ pointsPrel: v }) }
                                    disabled={ [CSV_EXPORT, EXCEL_EXPORT].includes(this.state.exportType) && !this.state.dataType }
                                    hideNull
                                />
                            </Box>
                            <SelectStationModal
                                onClose={ this.onCloseModal }
                                selectStationIsOpen={ this.state.selectStationIsOpen }
                                selectedStations={ this.state.selectedStations }
                                stationType='hydrometry'
                                onChangeSelectedStation={ tmpStations => this.setState({ selectedStations: tmpStations }) }
                            />
                        </CardContent>
                    </Card>
                    <CardTable
                        title={ i18n.manualExportsInProgress }
                        rows={ dataCurrentExports }
                        headers={ [STATUS_HEADER, FILE_LABEL_HEADER, 'duration', 'size', 'creationDate', 'lastExecutionDate', 'exportName', 'job', 'progression'] }
                        rowsPerPageOptions={ nbPerPageLabelTiny }
                        defaultSort={{ column: 'lastExecutionDate', direction: SORT.DESC }}
                    />
                    <CardTable
                        title={ i18n.exportsScheduled }
                        rows={ dataScheduledExports }
                        headers={ [STATUS_HEADER, SCHEDULED_NAME_HEADER, SCHEDULED_FILE_LABEL_HEADER, 'duration', 'size', 'creationDate', 'lastExecutionDate', 'exportName', SCHEDULED_JOB_HEADER, 'progression'] }
                        rowsPerPageOptions={ nbPerPageLabelTiny }
                        defaultSort={{ column: 'lastExecutionDate', direction: SORT.DESC }}
                        lineActions={[
                            { icon: 'play_circle_outline', onClick: row => this.props.relaunchExportTmp(row.exportTmp).then(() => this.regularProgressUpdate(4)), tooltip: i18n.relaunch },
                            { icon: 'edit', onClick: row => this.openEditExport(row.exportTmp), tooltip: i18n.edit },
                            { icon: 'delete', onClick: row => setConfirmationModal(() => {
                                StationAction.deleteExportTmp(row.exportTmp).then(() => this.regularProgressUpdate())
                            }), tooltip: i18n.delete },
                        ]}
                    />
                    <ScheduledExportEditModal
                        open={ this.state.editOpen }
                        onClose={ this.closeEditExport }
                        onSaveAndRun={ this.onSaveAndRunEdit }
                        title={ this.state.editExport?.name ? `${i18n.editExport} - ${this.state.editExport.name}` : i18n.editExport }
                    >
                        <Grid container spacing={ 1 }>
                            <Grid size={ 4 }>
                                <Select
                                    label={ i18n.exportName }
                                    options={ EXPORT_TYPE_OPTIONS }
                                    value={ this.state.exportType }
                                    disabled
                                />
                            </Grid>
                            <Grid size={ 4 }>
                                <Select
                                    label={ i18n.job }
                                    options={ this.state.jobs }
                                    value={ this.state.editJobId }
                                    onChange={ v => this.setState({ editJobId: v }) }
                                    keyValue='jobId'
                                    keyLabel='jobName'
                                />
                            </Grid>
                        </Grid>
                        { this.getExportPanel({ inPopin: true }) }
                        <StationsPointPrelTable
                            stations={ this.state.selectedStations.map(s => ({ id: s.id, code: s.code, name: s.name })) }
                            pointsPrel={ this.state.pointsPrel }
                            points={ this.props.stationPointsPrel }
                            dataType={ this.state.dataType }
                            onChange={ v => this.setState({ pointsPrel: v }) }
                            disabled={ [CSV_EXPORT, EXCEL_EXPORT].includes(this.state.exportType) && !this.state.dataType }
                            hideNull
                        />
                    </ScheduledExportEditModal>
                </Grid>
            </Grid>
        )
    }
}

HydrometricStationsExportApp.propTypes = ({
    hydrometricStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoHydrometricStation)),
    setTitle: PropTypes.func,
    fetchEnvironmentModelsByType: PropTypes.func,
    typeEnvironmentModels: PropTypes.arrayOf(PropTypes.string),
    exportModel: PropTypes.func,
    waitStart: PropTypes.func,
    waitStop: PropTypes.func,
    toastrWarning: PropTypes.func,
    exportJobsTmp: PropTypes.arrayOf(PropTypes.instanceOf(DtoExportJob)),
    fetchExportJobsTmp: PropTypes.func,
    fetchHydrometryDataTypes: PropTypes.func,
    runExportTmp: PropTypes.func,
    relaunchExportTmp: PropTypes.func,
    updateExportTmp: PropTypes.func,
    hydrometryDataTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoParametrageDataType)),
    push: PropTypes.func,
})

const mapStateToProps = store => ({
    hydrometricStations: store.HydrometryReducer.hydrometricStations,
    typeEnvironmentModels: store.ExportReducer.typeEnvironmentModels,
    exportJobsTmp: store.StationReducer.exportJobsTmp,
    stationPointsPrel: store.StationReducer.pointsPrelByType.hydrometry || [],
    hydrometryDataTypes: store.HydrometryReducer.hydrometryDataTypes,
})

const mapDispatchToProps = {
    setTitle: HomeAction.setTitle,
    fetchHydrometryDataTypes: HydrometryAction.fetchHydrometryDataTypes,
    fetchEnvironmentModelsByType: ExportAction.fetchEnvironmentModelsByType,
    runExportTmp: ExportAction.runExportTmp,
    relaunchExportTmp: ExportAction.relaunchExportTmp,
    updateExportTmp: ExportAction.updateExportTmp,
    exportModel: ExportAction.exportModel,
    toastrWarning: ToastrAction.warning,
    waitStart: WaitAction.waitStart,
    waitStop: WaitAction.waitStop,
    fetchExportJobsTmp: StationAction.fetchExportJobsTmp,
    fetchStationPointsPrel: StationAction.fetchStationPointsPrel,
    push,
}

export default connect(mapStateToProps, mapDispatchToProps)(HydrometricStationsExportApp)
